
import React from 'react'
import { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import $ from 'jquery';
import { gsap } from "gsap";
gsap.registerPlugin();

const Loading = ( { files = [],  onComplete, currentPath, isPageLoaded }) => {

  const [percent, setPercent] = useState(0);
  const location = useLocation();

  const loadingStrokeRef = useRef(null);
  const iconEyes = useRef(null);
  const loadingIcon = useRef(null);
  
  useEffect(()=>
  {
    if (isPageLoaded)
    {
      if(currentPath == "/") 
        loadingIcon.current.style.opacity = 1;
      else
        loadingIcon.current.style.opacity = 0;
    
    }
  }, [currentPath]);
  

  // Loading Calculation Logic
  useEffect(() => 
  {
    let loadingIconScale = 1;
   

    let loadingIconTop = "0%";
    if (window.innerWidth > 1920)
    { loadingIconTop = "25%"; loadingIconScale = 1.1;}
    else if (window.innerWidth > 1024)
      loadingIconTop = "21.5%";
    else if (window.innerWidth > 1023)
      loadingIconTop = "30%";

    else if (window.innerWidth > 767)
      loadingIconTop = "40%";
    else if (window.innerWidth < 767) 
    {
      loadingIconTop = "20%";
      iconEyes.current.style.display = "none";
    }


    let totalBytes = 0;
    let loadedBytes = 0;

    async function getFileSize(url) {
      const response = await fetch(url, { method: "HEAD" });
      const size = response.headers.get("Content-Length");
      return Number(size);
    }

    async function loadAllFiles() {
      totalBytes = 0;
      loadedBytes = 0;

      // 1) Get file sizes using HEAD (no download)
      const fileSizes = await Promise.all(
        files.map((file) => getFileSize(file))
      );

      totalBytes = fileSizes.reduce((a, b) => a + b, 0);
      console.log("Total bytes:", totalBytes);

      // 2) Download all files + track progress
      await Promise.all(
        files.map(async (file) => {
          const response = await fetch(file);
          const reader = response.body.getReader();

          return new Promise((resolve) => {
            function readChunk() {
              reader.read().then(({ done, value }) => {
                if (done) return resolve();

                loadedBytes += value.length;

                const p = Math.floor((loadedBytes / totalBytes) * 100);

                // Update width
                const w = Math.floor((180 * p) / 100);
                $("#loadingPercent").attr("width", w);

                // Update stroke offset
                const z = Math.floor((4400 * p) / 100);
                if (loadingStrokeRef.current) {
                  loadingStrokeRef.current.style.strokeDashoffset = z + 4400;
                }

                setPercent(p);
                readChunk();
              });
            }

            readChunk();
          });
        })
      );

      const tl = gsap.timeline();

      tl.to(".loading-icon",
      {
          scale: loadingIconScale,
          top: loadingIconTop,
          duration: 1,
          ease: "power2.inOut"

      }); 
      iconEyes.current.style.opacity = 1
      iconEyes.current.classList.add('active');
      

      
      if(currentPath != "/") 
      {
          loadingIcon.current.style.opacity = 0;
          onComplete();
          
      }
      else
      {
        setTimeout(()=>
        {
          onComplete();
         
        }, 850);
      }
    }
    loadAllFiles();

  }, []);



  // Eye Movement Logic
  useEffect(()=>
  {
    const root = document.documentElement;
    const rootStyles = getComputedStyle(root);
    let posX = 0;
    let posY = 0;
    let mouseX = 0;
    let mouseY = 0;
    let ease = .05;

    const handleMove = (e) => {

      mouseX = e.clientX;
      mouseY = e.clientY;

    };

    function update()
    {
      let perX = (mouseX / window.innerWidth)*100;
      let perY = (mouseY / window.innerHeight)*100;

      let destX = (((200 * perX)/100)*2)  - 200;
      let destY = (((160 * perY)/100)*2) - 125;
      
      posX += (destX - posX) * ease;
      posY += (destY - posY) * ease;

      const eyeScale = rootStyles.getPropertyValue("--eye-scale");
      iconEyes.current.style.transform  = "translate("+posX+"px, "+posY+"px) scale("+eyeScale+")";

      requestAnimationFrame(update);
    }

    update();

    window.addEventListener("mousemove", handleMove);
    return () => window.removeEventListener("mousemove", handleMove);

  },[]);




  return (
 
  
  <div className="loading-icon-wrapper">
    <svg className="loading-icon" ref={loadingIcon} width="1823" height="950" viewBox="0 0 1823 950" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <clipPath id="textMask">
          <rect x="0" y="400" width="100%" height="160" fill="white"></rect>
        </clipPath>
      </defs>
      <g>
        <path className="stroke" ref={loadingStrokeRef} strokeDashoffset="-4400" strokeDasharray="4400"
          d="M991.39 50H501.45C402.25 50 310.47 80.35 235.89 131.61C123.32 208.97 50 334.05 50 474.99C50 615.93 123.32 741.03 235.88 818.39C310.46 869.64 402.22 900 501.44 900H1321.33C1570.26 900 1772.77 709.36 1772.77 475.01C1772.77 240.66 1570.27 50.01 1321.33 50.01H1321.34L991.4 50"
          stroke="#fa263d" strokeWidth="100" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      
      <g style={{clipPath: 'url(#textMask)'}}>
        <text id="txt" x="300" y="750" fill="#fff" fontSize="200">
          Featured Work
        </text>
      </g>

      <g className="eyes" ref={iconEyes}>
        <circle cx="501" cy="475" r="100" fill="white" />
        <circle cx="1322" cy="475" r="100" fill="white" />
      </g>

    </svg>

  </div>



 
  )
}

export default Loading
